import React, { useEffect } from 'react';

import { FormattedMessage } from 'react-intl';

import StatusErrorIcon from '@atlaskit/icon/core/status-error';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/text';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';

import { useProductDependencies } from '../../../../controllers/use-product-dependencies';
import { messages } from './messages';

const inlineStyles = xcss({
	marginTop: 'space.150',
});

export const LoadingCardsError = ({ error }: { error: Error }): React.JSX.Element => {
	const { submitError } = useProductDependencies();

	useEffect(() => {
		submitError?.(error);
	}, [error, submitError]);

	return (
		<Inline space="space.100" alignBlock="center" xcss={inlineStyles}>
			<StatusErrorIcon label="error" color={token('color.icon.danger')} />

			<Text weight="medium" size="medium" color="color.text">
				<FormattedMessage {...messages.errorLoadingCardsPreamble} />
			</Text>

			<Text weight="medium" size="medium" color="color.text.subtlest">
				<FormattedMessage {...messages.errorLoadingCardsSupport} />
			</Text>
		</Inline>
	);
};
